export default __webpack_public_path__ + "locales/sk/DeleteThirdPartyDialog.json?hash=ba672c9183a141ac02983e0ecdb2765b";